import React from 'react';

const PersonalInfoStep = ({ register, errors, watch }) => {
    const isDominionMember = watch('isDominionMember');

    const nigerianStates = [
        'Abia', 'Adamawa', 'Akwa Ibom', 'Anambra', 'Bauchi', 'Bayelsa', 'Benue',
        'Borno', 'Cross River', 'Delta', 'Ebonyi', 'Edo', 'Ekiti', 'Enugu',
        'FCT', 'Gombe', 'Imo', 'Jigawa', 'Kaduna', 'Kano', 'Katsina', 'Kebbi',
        'Kogi', 'Kwara', 'Lagos', 'Nasarawa', 'Niger', 'Ogun', 'Ondo', 'Osun',
        'Oyo', 'Plateau', 'Rivers', 'Sokoto', 'Taraba', 'Yobe', 'Zamfara'
    ];

    return (
        <div>
            <h4 className="mb-4">
                <i className="fas fa-user me-2 text-primary"></i>
                Personal Information
            </h4>

            {/* Dominion City Membership */}
            <div className="row mb-3">
                <div className="col-md-6">
                    <label className="form-label">Are you a member of Dominion City? *</label>
                    <div className="form-check mb-2">
                        <input
                            className="form-check-input"
                            type="radio"
                            value={true}
                            {...register('isDominionMember')}
                            id="dominionYes"
                        />
                        <label className="form-check-label" htmlFor="dominionYes">Yes</label>
                    </div>
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            value={false}
                            {...register('isDominionMember')}
                            id="dominionNo"
                        />
                        <label className="form-check-label" htmlFor="dominionNo">No</label>
                    </div>
                    {errors.isDominionMember && (
                        <div className="text-danger small mt-1">{errors.isDominionMember.message}</div>
                    )}
                </div>
                {isDominionMember === 'true' && (
                    <div className="col-md-6">
                        <label className="form-label">Which Dominion City Chapter? *</label>
                        <input
                            type="text"
                            className={`form-control ${errors.dominionChapter ? 'is-invalid' : ''}`}
                            placeholder="Enter chapter name"
                            {...register('dominionChapter')}
                        />
                        {errors.dominionChapter && (
                            <div className="invalid-feedback">{errors.dominionChapter.message}</div>
                        )}
                    </div>
                )}
            </div>

            {/* Basic Information */}
            <div className="row mb-3">
                <div className="col-md-4">
                    <label className="form-label">Surname *</label>
                    <input
                        type="text"
                        className={`form-control ${errors.personalData?.surname ? 'is-invalid' : ''}`}
                        placeholder="Enter surname"
                        {...register('personalData.surname')}
                    />
                    {errors.personalData?.surname && (
                        <div className="invalid-feedback">{errors.personalData.surname.message}</div>
                    )}
                </div>
                <div className="col-md-4">
                    <label className="form-label">First Name *</label>
                    <input
                        type="text"
                        className={`form-control ${errors.personalData?.firstName ? 'is-invalid' : ''}`}
                        placeholder="Enter first name"
                        {...register('personalData.firstName')}
                    />
                    {errors.personalData?.firstName && (
                        <div className="invalid-feedback">{errors.personalData.firstName.message}</div>
                    )}
                </div>
                <div className="col-md-4">
                    <label className="form-label">Other Names</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter other names"
                        {...register('personalData.otherNames')}
                    />
                </div>
            </div>

            <div className="row mb-3">
                <div className="col-md-4">
                    <label className="form-label">Gender *</label>
                    <select
                        className={`form-select ${errors.personalData?.gender ? 'is-invalid' : ''}`}
                        {...register('personalData.gender')}
                    >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        {/*<option value="Other">Other</option>*/}
                    </select>
                    {errors.personalData?.gender && (
                        <div className="invalid-feedback">{errors.personalData.gender.message}</div>
                    )}
                </div>
                <div className="col-md-4">
                    <label className="form-label">Date of Birth (day/month/year) *</label>
                    <input
                        type="text"
                        placeholder="dd/mm/yyyy"
                        className={`form-control ${errors.personalData?.dateOfBirth ? 'is-invalid' : ''}`}
                        {...register('personalData.dateOfBirth')}
                    />
                    {errors.personalData?.dateOfBirth && (
                        <div className="invalid-feedback">{errors.personalData.dateOfBirth.message}</div>
                    )}
                </div>
                <div className="col-md-4">
                    <label className="form-label">Marital Status *</label>
                    <select
                        className={`form-select ${errors.personalData?.maritalStatus ? 'is-invalid' : ''}`}
                        {...register('personalData.maritalStatus')}
                    >
                        <option value="">Select Status</option>
                        <option value="Single">Single</option>
                        <option value="Married">Married</option>
                        <option value="Divorced">Divorced</option>
                        <option value="Widowed">Widowed</option>
                        <option value="Separated">Separated</option>
                    </select>
                    {errors.personalData?.maritalStatus && (
                        <div className="invalid-feedback">{errors.personalData.maritalStatus.message}</div>
                    )}
                </div>
            </div>

            {/* Contact Information */}
            <div className="row mb-3">
                <div className="col-md-6">
                    <label className="form-label">WhatsApp Number</label>
                    <input
                        type="tel"
                        className={`form-control ${errors.personalData?.whatsappNumber ? 'is-invalid' : ''}`}
                        placeholder="+234 123 456 7890"
                        {...register('personalData.whatsappNumber')}
                    />
                    {errors.personalData?.whatsappNumber && (
                        <div className="invalid-feedback">{errors.personalData.whatsappNumber.message}</div>
                    )}
                </div>
                <div className="col-md-6">
                    <label className="form-label">Phone Number *</label>
                    <input
                        type="tel"
                        className={`form-control ${errors.personalData?.phoneNumber ? 'is-invalid' : ''}`}
                        placeholder="+234 123 456 7890"
                        {...register('personalData.phoneNumber')}
                    />
                    {errors.personalData?.phoneNumber && (
                        <div className="invalid-feedback">{errors.personalData.phoneNumber.message}</div>
                    )}
                </div>
            </div>

            <div className="row mb-3">
                <div className="col-md-6">
                    <label className="form-label">Email Address</label>
                    <input
                        type="email"
                        className={`form-control ${errors.personalData?.email ? 'is-invalid' : ''}`}
                        placeholder="Enter email address"
                        {...register('personalData.email')}
                    />
                    {errors.personalData?.email && (
                        <div className="invalid-feedback">{errors.personalData.email.message}</div>
                    )}
                </div>
                <div className="col-md-6">
                    <label className="form-label">Occupation</label>
                    <input
                        type="text"
                        className={`form-control ${errors.personalData?.occupation ? 'is-invalid' : ''}`}
                        placeholder="Enter occupation"
                        {...register('personalData.occupation')}
                    />
                    {errors.personalData?.occupation && (
                        <div className="invalid-feedback">{errors.personalData.occupation.message}</div>
                    )}
                </div>
            </div>

            {/* Address Information */}
            <div className="mb-3">
                <label className="form-label">Residential Address *</label>
                <textarea
                    className={`form-control ${errors.personalData?.residentialAddress ? 'is-invalid' : ''}`}
                    placeholder="Enter full residential address"
                    rows="3"
                    {...register('personalData.residentialAddress')}
                />
                {errors.personalData?.residentialAddress && (
                    <div className="invalid-feedback">{errors.personalData.residentialAddress.message}</div>
                )}
            </div>

            <div className="row mb-3">
                <div className="col-md-6">
                    <label className="form-label">State of Origin *</label>
                    <select
                        className={`form-select ${errors.personalData?.stateOfOrigin ? 'is-invalid' : ''}`}
                        {...register('personalData.stateOfOrigin')}
                    >
                        <option value="">Select State</option>
                        {nigerianStates.map(state => (
                            <option key={state} value={state}>{state}</option>
                        ))}
                    </select>
                    {errors.personalData?.stateOfOrigin && (
                        <div className="invalid-feedback">{errors.personalData.stateOfOrigin.message}</div>
                    )}
                </div>
                <div className="col-md-6">
                    <label className="form-label">Local Government Area (LGA)</label>
                    <input
                        type="text"
                        className={`form-control ${errors.personalData?.lga ? 'is-invalid' : ''}`}
                        placeholder="Enter LGA"
                        {...register('personalData.lga')}
                    />
                    {errors.personalData?.lga && (
                        <div className="invalid-feedback">{errors.personalData.lga.message}</div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PersonalInfoStep;